import { Injectable, inject, signal } from '@angular/core';
import { restManager } from 'app/ajs-upgraded-providers';
import { UserActiveSessionManagerService } from 'src/app/core';


@Injectable({
    providedIn: 'root'
})
export class TabSettingsUmService {
    userActiveSessionManagerService = inject(UserActiveSessionManagerService);
    restManagerService = inject(restManager);
    shopOwner = signal<any>({});

    async getShopOwner() {
        try {
            await this.restManagerService.getOne("billing_data");
    
            this.shopOwner.set({
                username: this.userActiveSessionManagerService.getSession()?.username
            });
        } catch (error: any) {
            this.shopOwner.set(error?.data?.error?.message?.owner_data);
        }
    }
}